export const COMPANY_SIGNATURE_CONSENT = 'I am authorized to sign for Tew & Taylor. I adopt the displayed signature of my verified name as my electronic signature on this contract.';
export function validCompanySignature(signature, name) {
  return !!signature && typeof signature === 'object' && !Array.isArray(signature)
    && Object.keys(signature).sort().join() === 'consentText,format,name,signedDate'
    && signature.format === 'typed-company-signature-v1' && signature.name === name
    && signature.consentText === COMPANY_SIGNATURE_CONSENT
    && typeof signature.signedDate === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(signature.signedDate)
    && Number.isFinite(Date.parse(signature.signedDate)) && new Date(signature.signedDate).toISOString().slice(0, 10) === signature.signedDate;
}
